'use strict';

var VerticalScrollContentController = function ($scope, $element, $attrs) {
    var week = $scope.startWeek;
    $scope.$on('vertical-srcoll:scroll-to-element', function (event, toElement) {
        if ($element[0].contains(toElement[0])) {
            $element[0].scrollTop = toElement[0].offsetTop;
        }
    });

    $scope.$on('vertical-srcoll:scroll-to-top', function (event) {
        $element[0].scrollTop = 0;
    });

    $scope.$on('scroll-directive:scroll-left', function (event, data) {
        if ($element.parent()[0] == data.element) {
            if ($scope.isFirstWeek) {
                return;
            }
            --week;
            $scope.reloadWeek(week);
            $element[0].scrollLeft = 0;
            $element[0].scrollTop = 0;
        }
    });

    $scope.$on('scroll-directive:scroll-right', function (event, data) {
        if ($element.parent()[0] == data.element) {
            if ($scope.isLastWeek) {
                return;
            }
            ++week;
            $scope.reloadWeek(week);
            $element[0].scrollLeft = 0;
            $element[0].scrollTop = 0;
        }
    });

    //scroll synchronization
    var container = $element.parent()[0];
    var master = $element;
    var slave = angular.element(container.getElementsByClassName('js-sync-scroll'));
    master.on('scroll', function () {
        slave[0].scrollLeft = this.scrollLeft;
    });
    slave.on('scroll', function () {
        master[0].scrollLeft = this.scrollLeft;
    });
};

VerticalScrollContentController.$inject = ['$scope', '$element', '$attrs'];

var verticalScrollContentDirective = function() {
    return {
        restrict: 'A',
        controller: VerticalScrollContentController
    }
};

// angular.module('OSS').directive('verticalScrollContent', function () {
//     return {
//         restrict: 'A',
//         controller: VerticalScrollContentController
//     }
// });

var VerticalScrollContentItemLink = function ($scope, $element, $attrs) {
    $attrs.$observe('selected', function (val) {
        if (val === "true") {
            $scope.$emit('vertical-srcoll:scroll-to-element', $element);
        }
    });
};

VerticalScrollContentItemLink.$inject = ['$scope', '$element', '$attrs'];

var verticalScrollContentItemDirective = function() {
    return {
        restrict: 'A',
        link: VerticalScrollContentItemLink
    }
};

// module.exports = function () {
//     return {
//         restrict: 'A',
//         link: VerticalScrollContentItemLink
//     }
// };

module.exports = {
    verticalScrollContentDirective: verticalScrollContentDirective,
    verticalScrollContentItemDirective: verticalScrollContentItemDirective
};
